<template>
  <Layout>
    <div fluid class="d-flex justify-content-center align-items-center mt-5">
      <div class="custom-card-description shadow-lg text-center p-4 rounded-lg w-100">

        <div class="d-flex align-items-center justify-content-center mb-3">
          <div v-if="step > 1 && step < 5">
            <img
              src="@/assets/icons/arrow-left.svg"
              @click="goPreviousStep"
              alt="Back"
              height="25"
              class="mr-2"
              style="cursor: pointer;"
            />
          </div>

          <div v-else-if="step == 6">
            <img
              src="@/assets/icons/refresh-round.svg"
              @click="goToFirstStep"
              alt="Refresh"
              height="25"
              class="mr-2"
              style="cursor: pointer;"
            />
          </div>

          <h1 class="font-weight-bold text-primary text-uppercase mb-0" style="font-size: 20px;">
            {{ stepTitle }}
          </h1>
        </div>

        <p class="text-muted" style="font-size: 14px;">
          {{ stepDescription }}
        </p>
      </div>
    </div>

    <div fluid class="d-flex justify-content-center align-items-center mt-5">
      <!-- Step 1: Document Selection -->
      <div v-if="step == 1" class="row w-100 h-100 justify-content-center align-items-stretch">
        <div
          v-for="(doc, index) in documents"
          :key="index"
          class="col-12 col-md-5 mb-4 d-flex"
          style="cursor: pointer;"
          @click="setSelectedDocument(doc)"
        >
          <div class="custom-card shadow-lg hover-shadow-2xl text-center p-4 rounded-lg w-100">
            <h2 class="font-weight-bold text-primary mb-4 text-uppercase" style="font-size: 18px;">
              {{ doc.title }}
            </h2>
            <p class="text-muted mb-4" style="font-size: 1.1rem;">
              Analyse OCR pour <span class="text-uppercase">{{ doc.label }}</span>.
            </p>

            <img
              :src="doc.image"
              :alt="doc.alt"
              class="logo img-fluid mb-4"
              style="width: 250px; height: auto;"
            />
          </div>
        </div>
      </div>

      <!-- Step 2: CIN Type Selection -->
      <div v-else-if="step == 2" class="row w-100 h-100 justify-content-center align-items-stretch">
        <div
          v-for="(cinType, index) in cinTypes"
          :key="index"
          class="col-12 col-md-5 mb-4 d-flex"
          style="cursor: pointer;"
        >
          <div
            class="custom-card shadow-lg text-center p-4 rounded-lg w-100"
            :class="{ 'card-disabled': cinType.disabled }"
                      @click="setSelectedType(cinType)"

          >
            <h2 class="font-weight-bold text-primary mb-4 text-uppercase" style="font-size: 18px;">
              {{ cinType.type }}
            </h2>
            <p class="text-muted mb-4" style="font-size: 1.1rem;">
              Analyse OCR pour <span class="text-uppercase">{{ cinType.type }}</span>.
            </p>

            <img
              :src="cinType.image"
              :alt="'Image ' + cinType.type"
              class="logo img-fluid mb-4"
              style="width: 250px; height: auto;"
            />
          </div>
        </div>
      </div>

      <!-- Step 3: Upload Method Selection -->
      <div v-else-if="step == 3" class="row w-100 h-100 justify-content-center align-items-stretch">
        <div
          v-for="(uploadMethode, index) in uploadMethodes"
          :key="index"
          class="col-12 col-md-5 mb-4 d-flex"
          style="cursor: pointer;"
          @click="setSelectedMethod(uploadMethode)"
        >
          <div class="custom-card shadow-lg hover-shadow-2xl text-center p-4 rounded-lg w-100">
            <h2 class="font-weight-bold text-primary mb-4 text-uppercase" style="font-size: 18px;">
              {{ uploadMethode.name }}
            </h2>
            <p class="text-muted mb-4" style="font-size: 1.1rem;">
              {{ uploadMethode.description }}
            </p>

            <img
              :src="uploadMethode.image"
              :alt="'Image ' + uploadMethode.name"
              class="logo img-fluid mb-4"
              style="width: 150px; height: auto;"
            />
          </div>
        </div>
      </div>


      <div v-else-if="step == 4" class="row w-100 h-100 justify-content-center align-items-stretch">
        <div v-if="selectedUploadMethode.value === 1" class="col-12 col-md-8 m-4 d-flex">
          <div class="custom-card shadow-lg hover-shadow-2xl text-center p-4 rounded-lg w-100">

            <div v-if="this.selectedDocument.type === this.CIN ">
              
              <div class="text-center">
                <h2 class="font-weight-bold text-primary mb-4" style="font-size: 18px;">
                  Déposez votre carte d’identité ici
                </h2>
                <p class="text-muted mb-4" style="font-size: 1.1rem;">
                  Glissez et déposez votre carte d’identité pour lancer l'analyse OCR.
                </p>
              </div>
              
              <div class="row">
                <div class="col-md-6 col-12" v-if="selectedCinType && selectedCinType.value == 1">

                  <div class="text-center m-4">
                    <CustomDropzone
                        :key="dropzoneKey"
                        ref="customDropzone1" 
                        :max-files="this.maxFiles"
                        :max-file-size-in-mb="15"
                        accepted-files="image/jpeg,image/png"
                        upload-message="Déposez votre carte d’identité (FACE RECTO) ici"
                        :format-message=this.formatMessage
                        @upload-success="onUploadSuccess"
                      />
                  </div>

                </div>
                <div :class="selectedCinType && selectedCinType.value == 1 ? 'col-md-6 col-12' :'col-12'">

                    <div class="text-center m-4">
                      <CustomDropzone
                          :key="dropzoneKey"
                          ref="customDropzone2" 
                          :max-files="this.maxFiles"
                          :max-file-size-in-mb="15"
                          accepted-files="image/jpeg,image/png"
                          upload-message="Déposez votre carte d’identité (FACE VERSO) ici"
                          :format-message=this.formatMessage
                          @upload-success="onUploadSecondDocumentSuccess"
                        />
                    </div>

                </div>
              </div>

              <div class="row text-center">
                <div class="col-12 d-flex justify-content-end">

                  <b-button variant="outline-danger text-uppercase" size="sm" class="mt-3 mr-2" @click="resetAllDropzones">
                    Ré-initialiser
                  </b-button>

                  <b-button variant="outline-primary" size="sm"  class="mt-3 ml-2 text-uppercase" @click="ocrExtractData">
                    Envoyer
                  </b-button>
                </div>
              </div>

            </div>
            <div v-else>
                <h2 class="font-weight-bold text-primary mb-4" style="font-size: 18px;">
                  Déposez votre passport ici
                </h2>
                <p class="text-muted mb-4" style="font-size: 1.1rem;">
                  Glissez et déposez votre fichier pour lancer l'analyse OCR.
                </p>

                <div class="text-center m-4">
                  <CustomDropzone
                      :key="dropzoneKey"
                      ref="customDropzone3" 
                      :max-files="this.maxFiles"
                      :max-file-size-in-mb="50"
                      accepted-files="image/jpeg,image/png"
                      upload-message="Déposez votre/vos image(s) ici"
                      :format-message=this.formatMessage
                      @upload-success="onUploadSuccess"
                    />
                </div>

                <div class="row text-center">
                  <div class="col-12 d-flex justify-content-end">

                    <b-button variant="outline-danger text-uppercase" size="sm" class="mt-3 mr-2" @click="resetAllDropzones">
                      Ré-initialiser
                    </b-button>

                    <b-button variant="outline-primary" size="sm"  class="mt-3 ml-2 text-uppercase" @click="ocrExtractData">
                      Envoyer
                    </b-button>
                  </div>
                </div>

            </div>
          </div>
        </div>

        <div v-if="selectedUploadMethode.value === 2" class="col-12 col-md-8 mb-4 d-flex">
          <div class="custom-card shadow-lg hover-shadow-2xl text-center p-4 rounded-lg w-100">
            <h2 class="font-weight-bold text-primary mb-4" style="font-size: 18px;">
              Capturez une photo de votre {{ this.selectedDocument.type === this.CIN
                ? "carte d’identité"
                : "passeport" }}
              <span v-if="this.selectedDocument.type === this.CIN" class="font-weight-bold text-uppercase">
                (FACE RECTO)
              </span>
            </h2>
            <p class="text-muted mb-4" style="font-size: 1.1rem;">
              Cliquez pour ouvrir la caméra et capturer une photo pour l'analyse OCR.
            </p>


          <div v-if="!cameraReady && !cameraError" class="d-flex justify-content-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Chargement...</span>
            </div>
          </div>

          <div v-show="cameraReady" class="camera-wrapper position-relative">
            <video v-show="displayCameraVideo"
              ref="videoElement"
              autoplay
              playsinline
              width="100%"
              height="auto"
              :class="{ 'camera-disabled': takePhotoDisabled }"
            ></video>

            
            <div v-if="!displayCameraVideo && previewImage" class="mt-3 d-flex flex-column align-items-center">
              <div :class="extractedDataInProgress || (extractedJson && Object.keys(extractedJson).length > 0) ? 'w-100' : 'col-12 col-md-6'">
                  <PreviewImage :src="previewImage" />
              </div>
            </div>

            <div v-if="takePhotoDisabled" class="camera-overlay">
              <b-spinner variant="light" />
            </div>

              <div class="row text-center">
                <div class="col-12 d-flex justify-content-end">

                  <b-button variant="outline-danger text-uppercase" size="sm" class="mt-3 mr-2" @click="showCameraVideo">
                    Ré-essayer
                  </b-button>

                  <b-button v-if="!displayCameraVideo && previewImage" variant="outline-primary" class="mt-3 text-uppercase" size="sm"
                    @click="nextStep(1)">
                    Suivant
                  </b-button>

                  <b-button v-else variant="outline-primary" size="sm"  class="mt-3 ml-2 text-uppercase" 
                    :disabled="takePhotoDisabled"
                    @click="takePhoto">
                    Capturer photo
                  </b-button>

                </div>
              </div>

            </div>

            <!-- Error message -->
            <b-alert v-if="cameraError" variant="danger" show class="mt-3 text-left">
              <strong>Erreur d'accès à la caméra :</strong><br>
              {{ cameraError }}
            </b-alert>

          </div>
        </div>
      </div>


      <div v-else-if="step == 5" class="row w-100 h-100 justify-content-center align-items-stretch">

        <div v-if="selectedUploadMethode.value === 2" class="col-12 col-md-8 mb-4 d-flex">
          <div class="custom-card shadow-lg hover-shadow-2xl text-center p-4 rounded-lg w-100">
            <h2 class="font-weight-bold text-primary mb-4" style="font-size: 18px;">
              Capturez une photo de votre {{ this.selectedDocument.type === this.CIN
                ? "carte d’identité"
                : "passeport" }}
              <span v-if="this.selectedDocument.type === this.CIN" class="font-weight-bold text-uppercase">
                (FACE VERSO)
              </span>
            </h2>
            <p class="text-muted mb-4" style="font-size: 1.1rem;">
              Cliquez pour ouvrir la caméra et capturer une photo pour l'analyse OCR.
            </p>


          <div v-if="!cameraReady && !cameraError" class="d-flex justify-content-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Chargement...</span>
            </div>
          </div>

          <div v-show="cameraReady" class="camera-wrapper position-relative">
            <video v-show="displayCameraVideo"
              ref="videoElement"
              autoplay
              playsinline
              width="100%"
              height="auto"
              :class="{ 'camera-disabled': takeSecondPhotoDisabled }"
            ></video>

            <div v-if="!displayCameraVideo && previewSecondImage" class="mt-3 d-flex flex-column align-items-center">
              <div :class="extractedDataInProgress || (extractedJson && Object.keys(extractedJson).length > 0) ? 'w-100' : 'col-12 col-md-6'">
                  <PreviewImage :src="previewSecondImage" />
              </div>
            </div>

            <div v-if="takeSecondPhotoDisabled" class="camera-overlay">
              <b-spinner variant="light" />
            </div>

              <div class="row">
                <div class="col-12 d-flex justify-content-end">

                  <b-button v-if="!displayCameraVideo && previewSecondImage" variant="outline-danger text-uppercase" size="sm" class="mt-3 mr-2" @click="showCameraVideo">
                    Ré-essayer
                  </b-button>

                  <b-button v-else variant="outline-danger text-uppercase" size="sm" class="mt-3 mr-2"                 
                    :disabled="previousStepDisabled"
                    @click="previousStep">
                    Précédent
                  </b-button>

                  <b-button v-if="!displayCameraVideo && previewSecondImage"  variant="outline-primary" class="mt-3 text-uppercase" size="sm"
                    @click="nextStep(2)">
                    Suivant
                  </b-button>

                  <b-button v-else variant="outline-primary" size="sm"  class="mt-3 ml-2 text-uppercase" 
                    :disabled="takeSecondPhotoDisabled"
                    @click="takeSecondPhoto">
                    Capturer photo
                  </b-button>

                </div>
              </div>

            </div>


            <!-- Error message -->
            <b-alert v-if="cameraError" variant="danger" show class="mt-3 text-left">
              <strong>Erreur d'accès à la caméra :</strong><br>
              {{ cameraError }}
            </b-alert>

          </div>
        </div>
      </div>


      <div v-if="step === 6 " class="document-scanner d-flex justify-content-center align-items-start">

        <div class="card w-100">
          <div class="card-body">

            <!-- Title -->
            <div class="text-center mb-3">
              <h1 class="font-weight-bold text-primary text-uppercase" style="font-size: 20px;">
                Documents soumis
              </h1>
              <p class="text-muted" style="font-size: 14px;">
                Veuillez envoyer le(s) document(s) afin de procéder à l’extraction automatique des informations.
              </p>
            </div>

            <div class="justify-content-center">
              <div class="row">
                <div v-if="selectedCinType && selectedCinType.value === 1" :class="selectedDocument && selectedDocument.type == this.CIN? 'col-12 col-md-6' : 'col-12'"> 
                    <PreviewImage :src="previewImage" />
                </div>
                <div v-if="this.selectedDocument.type == this.CIN"  :class="selectedCinType && selectedCinType.value === 1 ? 'col-12 col-md-6' : 'col-12'"> 
                  <div class="d-flex justify-content-center mb-3 w-100">
                    <PreviewImage :src="previewSecondImage" />
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <b-button variant="outline-primary" class="mt-3 text-uppercase" size="sm" @click="ocrExtractData">
                Envoyer
              </b-button>
            </div>  

          </div>
        </div>

      </div>


    </div>
  </Layout>
</template>



<script>
import { extractPaperCorners, warpPerspective, ocrCinEuro , ocrTnCinFull, ocrPassport } from '@/services/ocr-api';
//import { saveCinRectoData, saveCinFullData, savePassportData } from '@/services/collecting-data-api.js';
import Layout from "@/components/layout/LayoutScreen.vue";
import CustomDropzone from "@/components/common/customDropzone.vue";
import { initializeCamera, captureImage, closeCamera } from './cameraService.js';
import { drawLineOnImage } from './drawCorners.js';
import PreviewImage from '@/components/PreviewImage.vue';

export default {
  components: { Layout, CustomDropzone, PreviewImage },

  data() {
    return {
      CIN: "CIN",
      PP: "PP",
      mediaStream: null,
      cameraReady:null,
      cameraError: null,
      takePhotoDisabled: false,
      takeSecondPhotoDisabled: false,
      previousStepDisabled: false,

      paperCorners:null,
      documentUploaded: null,
      secondDocumentUploaded:null,

      firstDocument: null,
      secondDocument: null,

      selectedDocument: null,
      selectedCinType: null,
      selectedUploadMethode: null,
      corners:null,
      cinRecto: null,
      displayCameraVideo: true,

      extractedJson:{},

      step: 1,
      maxFiles:1,
      maxFileSizeInMB:50,
      dropzoneKey:0,

      ocrIsBusy:false,
      extractedDataInProgress: false,

      documents: [
        {
          type: "CIN",
          title: "Analyse Du CIN",
          label: "Carte Identité Nationale",
          color: "primary",
          image: require("@/assets/images/cin.png"),
          alt: "CIN Image",
        },
        {
          type: "PP",
          title: "Analyse Du Passeport",
          label: "Passeport",
          color: "success",
          image: require("@/assets/images/pp.png"),
          alt: "Passport Image",
        },
      ],

      cinTypes: [
        {
          value: 1,
          type: "Carte d’Identité Tunisienne",
          image: require("@/assets/images/cinTn.png"),
          disabled: false
        },
        {
          value: 2,
          type: "Carte d’Identité Européenne",
          image: require("@/assets/images/cinE.png"),
          disabled: false
        }
      ],

      uploadMethodes: [
        {
          value: 1,
          name: "Télécharger via Appareil",
          image: require("@/assets/images/upload.png"),
          description: "Téléchargez le fichier à partir de votre appareil pour lancer l'analyse OCR.",
        },
        {
          value: 2,
          name: "Capturer par Camera",
          image: require("@/assets/images/camera.png"),
          description: "Capturez une photo en temps réel avec votre caméra pour effectuer l'analyse OCR.",
        },
      ],
    };
  },

  methods: {

    nextStep(step) {

      if (step === 2) {
        this.stopCamera()
      }
      this.displayCameraVideo = true;
      this.previousStepDisabled = false;
      this.incrementSetp(1);
    },

    previousStep(){
      this.previousStepDisabled = true;
      this.decrementSetp(1);
    },

    formatLabel(key) {
      const withSpaces = key
        .replace(/([A-Z])/g, ' $1')
        .replace(/_/g, ' ')
        .toLowerCase();

      return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
    },

    isArabic(text) {
      return /[\u0600-\u06FF]/.test(text);
    },

    resetAllDropzones() {
      const dropzones = [
        this.$refs.customDropzone1,
        this.$refs.customDropzone2,
        this.$refs.customDropzone3
      ];

      dropzones.forEach(dz => {
        if (dz && dz.$refs.myVueDropzone) {
          dz.$refs.myVueDropzone.dropzone.removeAllFiles();
        }
      });
    },

    async onUploadSuccess(uploadFile) {
      try {
        this.ocrIsBusy = true;

        this.documentUploaded =
          uploadFile instanceof File
            ? uploadFile
            : uploadFile.raw || uploadFile.file;

        if (!(this.documentUploaded instanceof File)) {
          throw new Error("Invalid file object");
        }

        this.firstDocument = URL.createObjectURL(this.documentUploaded)

      } finally {
        this.ocrIsBusy = false;
      }
    },

    async onUploadSecondDocumentSuccess(uploadFile) {
        if (this.selectedDocument.type != this.CIN) {
          return
        }

      try {
        this.ocrIsBusy = true;

        this.secondDocumentUploaded =
          uploadFile instanceof File
            ? uploadFile
            : uploadFile.raw || uploadFile.file;

        if (!(this.secondDocumentUploaded instanceof File)) {
          throw new Error("Invalid file object");
        }

        this.secondDocument = URL.createObjectURL(this.secondDocumentUploaded)

      } finally {
        this.ocrIsBusy = false;
      }
    },


    setSelectedDocument(doc) {
      this.selectedDocument = doc;
      if (doc.type == this.CIN) {
        this.incrementSetp(1);
      } else {
        this.incrementSetp(2);
      }
    },

    setSelectedType(type) {
      this.selectedCinType = type;
      this.incrementSetp(1);
    },

    setSelectedMethod(uploadMethode) {
      this.selectedUploadMethode = uploadMethode;

      if(this.selectedUploadMethode && this.selectedUploadMethode.value === 2     &&
          this.selectedDocument && this.selectedDocument.type === this.CIN   && 
          this.selectedCinType && this.selectedCinType.value === 2){
        this.incrementSetp(2);

      } else {
        this.incrementSetp(1);
      }

    },

    goToFirstStep(){
        this.selectedDocument = null
        this.selectedCinType = null
        this.selectedUploadMethode = null
        this.documentUploaded= null,
        this.secondDocumentUploaded= null,
        this.firstDocument= null,
        this.secondDocument= null
        this.paperCorners= null,
        this.extractedJson= null,
        this.cinRecto= null
        this.corners= null,
        this.step= 1,
        window.location.reload();
    },

    goPreviousStep(){
      if(this.step == 2){
        this.selectedDocument = null
        this.decrementSetp(1)
      }else if(this.step == 3 && this.selectedDocument.type == this.CIN){
        this.selectedCinType = null
        this.selectedUploadMethode = null
        this.decrementSetp(1)
      }else if(this.step == 3 && this.selectedDocument.type == this.PP){
        this.selectedCinType = null
        this.selectedUploadMethode = null
        this.decrementSetp(2)
      }else if(this.step == 4){
        this.selectedUploadMethode = null
        this.decrementSetp(1)
      }
    },

    takeNewPhoto(){
      this.documentUploaded == null
      this.corners == null
      this.decrementSetp(1)
      if(this.selectedUploadMethode && this.selectedUploadMethode.value == 2){
        this.startCamera()
      }
    },

    incrementSetp(step) {
      this.step = this.step + step;
    },

    decrementSetp(step) {
      this.step = this.step - step;
    },

    handleDrop(event) {
      event.preventDefault();
      event.dataTransfer.files[0];
    },

    showCameraVideo(){
      this.displayCameraVideo= true
    },

    async startCamera() {
      await initializeCamera(this);
    },

    async stopCamera() {
      await closeCamera(this);
    },

    async takePhoto() {
      this.takePhotoDisabled = true;

      try {
        const dataUrl = await captureImage(this);

        if (!dataUrl) {
          throw new Error("No image captured");
        }

        const blob = await (await fetch(dataUrl)).blob();
        this.documentUploaded = new File([blob], "photo.png", { type: blob.type });

        this.firstDocument = URL.createObjectURL(blob);

        if (this.selectedDocument.type != this.CIN) {
          this.incrementSetp(2);
        }

      } catch (error) {
        console.error("takePhoto failed:", error);
        this.$bvToast?.toast("Erreur lors de la prise de photo", {
          variant: "danger",
          solid: true
        });
      } finally {
        this.takePhotoDisabled = false;
        this.displayCameraVideo= false;
         if (this.selectedDocument.type != this.CIN) {
          this.stopCamera()
        }
        
      }
    },

    async takeSecondPhoto() {

      if (this.selectedDocument.type != this.CIN) {
        return
      }

      this.takeSecondPhotoDisabled = true;

      try {
        const dataUrl = await captureImage(this);

        if (!dataUrl) {
          throw new Error("No image captured");
        }

        const blob = await (await fetch(dataUrl)).blob();
        this.SecondDocumentUploaded = new File([blob], "photo.png", { type: blob.type });

        this.secondDocument = URL.createObjectURL(this.SecondDocumentUploaded)

      } catch {
        this.$bvToast?.toast("Erreur lors de la prise de photo", {
          variant: "danger",
          solid: true
        });
      } finally {
        this.takeSecondPhotoDisabled = false;
        this.displayCameraVideo= false;
      }
    },

    //START API 

    /*
    async saveExtractedData() {
      try {
        const firstDocumentBlob = await (await fetch(this.firstDocument)).blob();
        const firstDocumentFile = new File([firstDocumentBlob], "firstDocument.png", { type: firstDocumentBlob.type });

        const secondDocumentBlob = await (await fetch(this.secondDocument)).blob();
        const secondDocumentFile = new File([secondDocumentBlob], "secondDocument.png", { type: secondDocumentBlob.type });

        if (this.selectedDocument.type === this.CIN) {
          await saveCinFullData(firstDocumentFile, secondDocumentFile, this.extractedJson);
          //await saveCinRectoData(file, this.extractedJson);
        } else {
          await savePassportData(firstDocumentFile, this.extractedJson);
        }

        this.extractedJson = false;
        this.extractedJson = {};
        Vue.prototype.$snotify.success("Données enregistrées avec succès !");
        
        setTimeout(() => {
          this.goToFirstStep()
        }, 500);

      } catch {
        Vue.prototype.$snotify.error("Erreur lors de l’enregistrement des données.");
      }
    },*/



    //START OCR IA API

    async extractPaperCornersfromImage() {
      const result = await extractPaperCorners(this.documentUploaded);

      if(result.success){
        this.corners = result.corners
        this.incrementSetp(1)
        await drawLineOnImage(this)
      }
    },


    async warpPerspective() {
      const cornersString = JSON.stringify(this.corners);
      const result = await warpPerspective(this.documentUploaded, cornersString);
      if(result){
          const blob = new Blob([result], { type: "image/png" });
          this.firstDocument = URL.createObjectURL(blob); 
        this.incrementSetp(1)
      }
    },

    async ocrExtractData() {
      this.extractedDataInProgress = true;

      try {
        if (this.selectedDocument && this.selectedDocument.type === this.CIN) {
          if (this.selectedCinType && this.selectedCinType.value === 1) {
            await this.ocrTnCinFull();
          } else {
             await this.ocrCinEuro();
          }
        } else {
          await this.ocrPassport();
        }
      } catch (error) {
        console.error("OCR extraction failed", error);
      } finally {
        this.extractedDataInProgress = false;

        setTimeout(() => {
          this.goToFirstStep()
        }, 500);
      }
    },


    async ocrCinEuro() {

      const blobFileDocument = await (await fetch(this.secondDocument)).blob();
      const file = new File([blobFileDocument], "file.png", { type: blobFileDocument.type });

      const result = await ocrCinEuro(file);

      if (result) {
        this.extractedJson = { ...result }; 
      }

    },

    async ocrTnCinFull() {
      
      const blobFirstDocument = await (await fetch(this.firstDocument)).blob();
      const firstDocumentAsFile = new File([blobFirstDocument], "rectoPhoto.png", { type: blobFirstDocument.type });

      const blobSecondDocument = await (await fetch(this.secondDocument)).blob();
      const secondDocumentAsFile = new File([blobSecondDocument], "versoPphoto.png", { type: blobSecondDocument.type });

      const result = await ocrTnCinFull(firstDocumentAsFile, secondDocumentAsFile);

      if (result) {
        this.extractedJson = { ...result }; 
      }

    },

    async ocrPassport() {
      
      const blob = await (await fetch(this.firstDocument)).blob();
      const firstDocumentAsFile = new File([blob], "photo.png", { type: blob.type });

      const result = await ocrPassport(firstDocumentAsFile);
      if(result){
        this.extractedJson = { ...result }; 
      }
    },

    //END OCR IA API


},


  computed:{
    formatMessage() {
      const formats = 'JPEG, PNG';
      return `Formats acceptés : ${formats} | ${this.maxFiles} fichiers - Taille max : ${this.maxFileSizeInMB} Mo`;
    },

    previewImage() {
      return this.firstDocument || null;
    },

    previewSecondImage() {
      return this.secondDocument || null;
    },

    documentUrl() {
      return this.documentUploaded ? URL.createObjectURL(this.documentUploaded) : '';
    },

    stepTitle() {
      switch (this.step) {
        case 1:
          return "Choisissez la Méthode d'Analyse OCR";
        case 2:
          return "Sélectionnez le type de la CIN";
        case 3:
          return "Choisissez la méthode de téléchargement";
        case 4:
          return "Préparez votre document pour l'analyse";
        case 5:
          return "Préparez votre document pour l'analyse";
        case 6:
          return "Vérifiez et corrigez les données extraites";
        default:
          return "Analyse OCR";
      }
    },
    stepDescription() {
      switch (this.step) {
        case 1:
          return "Sélectionnez un des documents ci-dessous pour lancer l'analyse OCR. Vous pouvez choisir entre la Carte d'Identité Nationale (CIN) ou le Passeport pour effectuer l'analyse.";
        case 2:
          return "Sélectionnez le type du document pour continuer l'analyse OCR.";
        case 3:
          return "Choisissez comment vous voulez fournir votre document: via téléchargement ou capture photo.";
        case 4:
          return "Préparez votre fichier ou capturez une photo pour lancer l'analyse OCR.";
        case 5:
          return "Préparez votre fichier ou capturez une photo pour lancer l'analyse OCR.";
        case 6:
          return "Vérifiez et corrigez les informations extraites avant de les enregistrer.";
        default:
          return "";
      }
    }
  },

  watch: {
    selectedUploadMethode(newValue) {
      if (newValue && newValue.value === 2) {
        this.startCamera();
      }
    },
  },
};
</script>


<style scoped>
.custom-card-description {
  max-width: 80%;
  margin: auto;
  background-color: #ffffff;
  color: #444;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  letter-spacing: 1.1px;
  text-align: justify; 
}

@media (max-width: 640px) {
  .custom-card-description {
    max-width: 90%;
  }
}

.custom-card-description:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.custom-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.custom-card h2 {
  font-size: 1.8rem;
  color: #444;
  font-weight: 600;
}

.b-button {
  padding: 15px 20px;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 50px;
  transition: background-color 0.3s, transform 0.3s;
}

.b-button:hover {
  background-color: #505050;
  color: white;
  transform: scale(1.05);
}

.b-icon {
  font-size: 1.5rem;
}

.logo {
  transition: transform 0.3s ease-in-out;
}

.logo:hover {
  transform: scale(1.1);
}

.animate__animated {
  animation-duration: 1.2s;
}

.animate__pulse {
  animation-name: pulse;
  animation-timing-function: ease-in-out;
}

.camera-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.camera-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
  filter: grayscale(100%);
}
</style>



<style>



.document-scanner{
  width: 80%;
}

@media (max-width: 640px) {
  .document-scanner {
    max-width: 90%;
  }
}


.scanner-wrapper {
  background: #fff;
  padding: 30px;
  border-radius: 20px;
  position: relative;
  width: 100%;
  max-width: 80%;
  text-align: center;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.4);
}

.corner-tr {
  top: 10px;
  right: 10px;
  border-left: none;
  border-bottom: none;
}

.corner-bl {
  bottom: 10px;
  left: 10px;
  border-right: none;
  border-top: none;
}
.shimmer-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 12px;
  max-width: 420px;
}

.shimmer-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.shimmer-label {
  width: 28%;
  height: 18px;
  border-radius: 6px;
  background: linear-gradient(90deg, #dddddd 25%, #f7f7f7 50%, #dddddd 75%);
  background-size: 300% 100%;
  animation: shimmer-slow 2.5s ease-in-out infinite;
  box-shadow:
    inset 0 1px 3px rgba(255,255,255,0.7),
    0 1px 2px rgba(0,0,0,0.05);
  transform-origin: center;
  transform: translateZ(0);
}

/* Input placeholder */
.shimmer-input {
  width: 100%;
  height: 42px;
  border-radius: 10px;
  background: linear-gradient(90deg, #e4e4e4 25%, #fafafa 50%, #e4e4e4 75%);
  background-size: 300% 100%;
  animation: shimmer-slow 2.5s ease-in-out infinite;
  box-shadow:
    inset 0 3px 8px rgba(255,255,255,0.9),
    0 3px 6px rgba(0,0,0,0.07);
  transform-origin: center;
  transform: translateZ(0);
}

/* Slight vertical bounce for subtle life */
.shimmer-group:hover .shimmer-input {
  animation-play-state: paused;
  box-shadow:
    inset 0 6px 12px rgba(255,255,255,0.95),
    0 6px 12px rgba(0,0,0,0.1);
  transform: scaleY(1.05);
  transition: all 0.3s ease;
}

/* Slow shimmer animation */
@keyframes shimmer-slow {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.camera-wrapper {
  width: 100%;
}

.camera-disabled {
  filter: blur(5px) grayscale(100%);
  transition: filter 0.3s ease;
}

.camera-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 45px; /* keeps button visible */
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}


</style>